import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import Header from '../containers/Header'
import Alerts from '../containers/Alerts'
import IdeaListSidebar from '../containers/IdeaListSidebar'
import IdeaPageSidebar from '../containers/IdeaPageSidebar'
import firebase from '../firebase'
/* import DevTools from 'mobx-react-devtools' */

function ContextualSidebar(props) {
    if (props.inPresent) {
        return props.children
    }
    if (props.inIdeaPage) {
        return <IdeaPageSidebar ideaKey={props.ideaKey}>{props.children}</IdeaPageSidebar>
    }
    return <IdeaListSidebar>{props.children}</IdeaListSidebar>
    //TODO: handle user and team profile pages
}

class App extends Component {

    componentDidMount() {
        const {stores} = this.props
        const {store, authStore, routingStore} = stores
        const {push} = routingStore

        this.unwatchAuth = authStore.watchAuth(user => {
            var connectedRef = firebase.database().ref('.info/connected')
            connectedRef.on('value', function (snap) {
                if (snap.val() === true) {
                    // We're connected (or reconnected)! Do anything here that should happen only if online (or on reconnect)
                    store.online = true
                    // store.errorAlert = undefined
                }else{
                    //NOT-CONNECTED
                    store.online = false
                    // store.errorAlert = 'Reconnecting... If you reload, changes will be lost!'
                }
            })

            const isLoggingOut = store.isLoggedIn && !(user!==null)
            const isLoggingIn = !store.isLoggedIn && (user!==null)

            if (isLoggingIn) {
                store.isLoggedIn = true
                push(store.redirectUrl)
            } else if (isLoggingOut) {
                // do any kind of cleanup or post-logout redirection here
                store.isLoggedIn = false
                push('/goodbye')
            }
        })
    }
    componentWillUnmount() {
        if (this.unwatchAuth) {
            this.unwatchAuth()
            this.unwatchAuth = null
        }
    }
    render() {
        const {stores} = this.props
        const {routingStore, store, prefStore} = stores
        const {location} = routingStore
        const {ideaKey, theIdea} = store
        let inPresent = location.pathname.startsWith('/present') ? true : false
        let inIdeaPage = location.pathname.startsWith('/idea/') ? true : false
        let showSidebar = (
            location.pathname.startsWith('/login')||
            location.pathname.startsWith('/signup')||
            location.pathname.startsWith('/forgot')||
            location.pathname.startsWith('/goodbye')
            ) ? false : true

        let hideOverFlow = ''
        let containerStyle = 'container'
        if (prefStore.majorMode !== undefined){
            if (location.pathname.startsWith('/ideas')){
                if (prefStore.majorMode === 2){
                    containerStyle = 'container-fluid'
                    hideOverFlow = 'hidden'
                }
            } else if (location.pathname.endsWith('/view')){
                containerStyle= 'container-fluid'
            }
            else if (location.pathname.startsWith('/idea-storage/')){
                containerStyle = 'container-fluid'
                hideOverFlow = ''
            }
            else {
                containerStyle = 'container'
            }
        }
        return (
                <div>
                   {/*  <DevTools
                        highlightTimeout={50000}
                    /> */}
                    {(!inPresent && showSidebar) &&
                        <Header/>
                    }
                    <Alerts/>
                    {showSidebar ? (
                        <ContextualSidebar ideaKey={ideaKey} inPresent={inPresent} inIdeaPage={inIdeaPage}>
                            <div>
                                {((location.pathname.startsWith('/idea-storage/'))) &&
                                <div className='storedWarningContainerList'>
                                    <div className='storedWarning'>
                                        Currently you are looking at the stored ideas. Keep in mind these ideas can not be edited unless reactivated as active ideas once again
                                    </div>
                                </div>
                                }
                                {((theIdea && theIdea.hasOwnProperty('status') && location.pathname.startsWith('/idea/'))) &&
                                <div className='storedWarningContainerView'>
                                    <div className='storedWarning'>
                                        Currently you are looking at the stored ideas. Keep in mind these ideas can not be edited unless reactivated as active ideas once again
                                    </div>
                                </div>
                                }
                                {location.pathname.startsWith('/idea-storage/') &&
                                    <div style={{height: 100+'%', overflowX: hideOverFlow}} className={containerStyle}>
                                        {this.props.children}
                                    </div>
                                }
                                {!location.pathname.startsWith('/idea-storage/') &&
                                    <div style={{overflowX: hideOverFlow}} className={containerStyle}>
                                        {this.props.children}
                                    </div>
                                }
                            </div>
                        </ContextualSidebar>
                    ) : (
                        <div className='container'>
                            {this.props.children}
                        </div>
                    )}
                </div>
        )
    }
}
export default inject("stores")(observer(App))



// WEBPACK FOOTER //
// ./src/containers/App.js